/* app/js/src/components/live/liveInput.component/liveInput.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  border: 1px dashed #dde3e7;
  display: inline-block;
  width: 19%;
  position: relative;
  max-width: 180px;
}
:host::after {
  padding-top: 83%;
  display: block;
  content: " ";
}
:host > div {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  color: #879baf;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: flex-start;
  justify-content: flex-start;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
:host > div .cta-wrapper {
  text-align: center;
  position: absolute;
  top: 35%;
}
:host > div .cta-wrapper svg {
  -webkit-transition: all 0.2s cubic-bezier(0.6, 0.04, 0.54, 0.99);
  transition: all 0.2s cubic-bezier(0.6, 0.04, 0.54, 0.99);
}
:host > div .cta-wrapper svg path {
  fill: #c6d2df;
  -webkit-transition: all 0.2s cubic-bezier(0.6, 0.04, 0.54, 0.99);
  transition: all 0.2s cubic-bezier(0.6, 0.04, 0.54, 0.99);
  transform-origin: center center;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
}
:host > div .cta-wrapper span {
  display: block;
  color: #c6d2df;
  cursor: default;
  font-size: 0.8em;
  margin-top: 10px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-transition: all 0.2s cubic-bezier(0.6, 0.04, 0.54, 0.99);
  transition: all 0.2s cubic-bezier(0.6, 0.04, 0.54, 0.99);
}
:host > div > header {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  justify-content: space-between;
  margin-top: 10px;
  width: 90%;
}
:host > div > header span {
  font-size: 0.7em;
  font-weight: 300;
  cursor: default;
  text-align: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
}
@media only screen and (max-width : 1390px) {
  :host > div > header span {
    font-size: 0.6em;
    white-space: nowrap;
  }
}
:host > div > header button {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  -webkit-flex: 3 0 0;
  -ms-flex: 3 0 0;
  flex: 3 0 0;
  max-width: 40px;
  display: none;
  background-color: #ffffff;
  color: #61b965;
  border: 1px solid #dde3e7;
  border-radius: 5px;
  font-size: 0.7em;
  line-height: 1em;
  padding: 0.5em 0.7em;
}
:host > div > header button:hover,
:host > div > header button.playing {
  background-color: #61b965;
  color: #ffffff;
}
:host > div > header button:hover.live,
:host > div > header button.playing.live {
  background-color: #ef5350;
  color: #ffffff;
}
:host > div > header button.live {
  color: #ef5350;
}
:host > div > header button:focus {
  outline: none;
}
@media only screen and (max-width : 1390px) {
  :host > div > header button {
    font-size: 0.6em;
    line-height: 0.8em;
    padding: 0.4em 0.2em;
    margin: 0 0.2em;
  }
}
:host > div .drag-mask {
  position: absolute;
  background-color: transparent;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
:host > div .player-wrapper {
  display: none;
  position: relative;
  width: 90%;
  height: 61%;
  margin-top: 5%;
}
:host > div .soundbar-wrapper {
  width: 90%;
}
:host > div.notEmpty {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
:host > div.notEmpty > header {
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
}
:host > div.notEmpty > header button {
  display: block;
}
:host > div.notEmpty .player-wrapper {
  display: block;
  -webkit-flex: 7 0 0;
  -ms-flex: 7 0 0;
  flex: 7 0 0;
}
:host > div.notEmpty > footer {
  color: #232f3a;
  font-size: 0.7em;
  padding: 0.5em;
  text-align: left;
  width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
:host:hover svg path {
  -ms-transform: rotate(270deg);
  -webkit-transform: rotate(270deg);
  transform: rotate(270deg);
  fill: #232f3a;
}
:host.drag-over {
  background-color: #eef2f6;
  border: 1px solid #bdcbd8;
}
:host.drag-over span {
  color: #232f3a;
}
:host.drag-over .cta-wrapper span {
  color: #232f3a;
}
:host.drag-over svg {
  opacity: 0;
}
/*# sourceMappingURL=liveInput.component.css.map */
